import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ManageVendor from "./manageVendor";
import {
    getVendorServiceDetail,
    postVendorService,
    updateVendorAllocation
} from "services/redux/installation/vendorAllocation/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
    vendorServiceDetail: state.vendorReducer.vendorServiceDetail,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getVendorServiceDetail,
            postVendorService,
            updateVendorAllocation,
            documentUploadUrl,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ManageVendor);
